/**
 * Confirmacao simples para acoes destrutivas ("Remover da régua").
 *
 * Existe porque um clique em botao vermelho nao pode ser irreversivel sem
 * uma segunda pergunta -- e porque o `Modal` do kit ja devolve o foco ao
 * botao que abriu, entao cancelar deixa a pessoa exatamente onde estava.
 */

import type { ReactNode } from 'react';
import { Button, Modal } from '../../../components/ui';

export function ModalConfirmar({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel,
  children,
}: {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
  readonly title: string;
  readonly description: ReactNode;
  readonly confirmLabel: string;
  readonly children?: ReactNode;
}): JSX.Element | null {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="danger" icon="x" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {children ?? <p className="text-sm text-ink-muted">Esta ação fica registrada na linha do tempo do lead.</p>}
    </Modal>
  );
}
